import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { money, surfaceSx } from "../center/ownerCenterUi";
import { minutesLabel } from "./ownerProjectUi";

function Metric({ label, value, helper = "" }) {
  return (
    <Box sx={{ minWidth: 0 }}>
      <Typography sx={{ color: "text.secondary", fontSize: ".68rem", fontWeight: 950, letterSpacing: ".045em" }}>{label}</Typography>
      <Typography sx={{ mt: .22, fontSize: { xs: "1.15rem", lg: "1.32rem" }, fontWeight: 1000, letterSpacing: "-.025em" }}>{value}</Typography>
      {helper ? <Typography sx={{ mt: .12, color: "text.secondary", fontSize: ".68rem" }}>{helper}</Typography> : null}
    </Box>
  );
}

export default function OwnerProjectSummaryStrip({ context }) {
  const commercial = context?.commercial || null;
  const time = context?.time || {};

  return (
    <Box data-owner-jarvis-section="project-summary" sx={{ ...surfaceSx, p: { xs: 1.5, md: 1.8 } }}>
      {commercial ? (
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4,minmax(0,1fr))" }, gap: { xs: 1.4, md: 2 } }}>
          <Metric label="VALOR" value={money(commercial.total, commercial.currency)} />
          <Metric label="COBRADO" value={money(commercial.paid, commercial.currency)} />
          <Metric label="PENDIENTE" value={money(commercial.outstanding, commercial.currency)} helper={commercial.paymentStatus === "paid" ? "Cobro completo" : "Según cobros registrados"} />
          <Metric label="TIEMPO REAL" value={Number(time.actualMinutes || 0) ? minutesLabel(time.actualMinutes) : "Sin horas registradas"} helper={time.entryCount ? `${time.entryCount} registro${time.entryCount === 1 ? "" : "s"}` : "Fuente: actividades del proyecto"} />
        </Box>
      ) : (
        <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={1.4} alignItems={{ sm: "center" }}>
          <Box>
            <Typography sx={{ fontWeight: 1000, fontSize: ".92rem" }}>Sin trabajo comercial vinculado</Typography>
            <Typography sx={{ mt: .2, color: "text.secondary", fontSize: ".75rem" }}>No se interpreta como valor cero: falta una venta principal inequívoca para este proyecto.</Typography>
          </Box>
          <Box sx={{ minWidth: { sm: 180 } }}><Metric label="TIEMPO REAL" value={Number(time.actualMinutes || 0) ? minutesLabel(time.actualMinutes) : "Sin horas registradas"} helper={time.entryCount ? `${time.entryCount} registro${time.entryCount === 1 ? "" : "s"}` : "Fuente: actividades del proyecto"} /></Box>
        </Stack>
      )}
    </Box>
  );
}
